import { createFileRoute, Outlet } from '@tanstack/react-router';

// ENG-871 Operating Costs: Overheads / Support / Value-adding baselines and
// the Support Log, factory-first, plus ENG-921's Cost to Produce views.
// Plain-string crumbs are enough until a child editor route needs `?factory=`
// threaded (see routes/shift-patterns/route.tsx for that resolver pattern).
export const Route = createFileRoute('/operating-costs')({
  staticData: {
    permissionSection: 'cost_to_produce',
    section: 'Operating Costs',
    breadcrumb: 'Operating Costs',
  },
  component: Outlet,
});
